module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="container-fluid">\n    <div class="row">\n        <div class="col-xs-12">\n          <div class="fmcy-menu-item-btn-close"></div>\n          <div class="fmcy-modal-content-region">\n            <div class="fmcy-modal-default-content-wrapper">\n              <div class="fmcy-modal-default-content">\n                <div class="fmcy-modal-default-content-icon">\n\n                </div>\n                <div class="fmcy-modal-default-title-text">\n                  '+
((__t=(title))==null?'':__t)+
'\n                </div>\n                <div class="fmcy-modal-default-content-text">\n                  '+
((__t=(description))==null?'':__t)+
'\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n</div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/modal/modal/modal.html
 ** module id = 1113
 ** module chunks = 1 139
 **/